import React, {
  createContext,
  useContext,
  useEffect,
  ReactNode,
  useState,
} from "react";
import { useGetBookingEngine } from "../hooks/";
import { BookingEngineDataInterface } from "./types";

interface BookingEngineContextProps {
  bookingEngineData: BookingEngineDataInterface | null;
  loading: boolean;
  errorMessage: string | null;
  accentColor: string;
}

const BookingEngineContext = createContext<
  BookingEngineContextProps | undefined
>(undefined);

export const BookingEngineProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { bookingEngineData, loading, errorMessage } = useGetBookingEngine();
  const [accentColor, setAccentColor] = useState("#5F7EFB");

  useEffect(() => {
    console.log("Booking Engine Data:", bookingEngineData);
    if (bookingEngineData && bookingEngineData.themeColor) {
      setAccentColor(bookingEngineData.themeColor); // Adjust the key to match your data structure
    }
  }, [bookingEngineData]);

  return (
    <BookingEngineContext.Provider
      value={{ bookingEngineData, loading, errorMessage, accentColor }}
    >
      {children}
    </BookingEngineContext.Provider>
  );
};

export const useBookingEngine = (): BookingEngineContextProps => {
  const context = useContext(BookingEngineContext);
  if (!context) {
    throw new Error(
      "useBookingEngine must be used within a BookingEngineProvider"
    );
  }
  return context;
};
